import React from 'react';
import PingStatus from './PingStatus';

export default function Zmonitoramento() {
  return (
    <PingStatus
      pingUrl="https://v1-csapi.compsoft.com.br:825/ping"
      restartKey="api_monitoramento"
      interval={20000}
    />
  );
}
